// 回避・見切りと床の帯 (ゾーン) のルール (2026-10-23 比較版・10-24 地割りだけ配布版へ)。
//
//   作者 (10-23 検収 kensyu-exec-answers-1023 Q-1「今のまま」のメモ): 「回避成功判定中は床技も食らわないようにするって、
//   全ボス共通のルールにできない？それをすることによって、何かズレが生じるとか、良くない技ができるんだったら教えてほしい」。
//   きっかけ = 介錯の地割りで、前回避で背中側へ抜け (見切り)、反撃の突き (1500px/s で約120px 滑る) が体を突き抜けて
//   前側の床の帯に入り被弾する (tests/exec_quake_counter_through.test.ts)。
//
//   配布版 (2026-10-24 作者「案1を地割りだけに」): 下の counter を介錯の地割り (exec_maulQuake) の帯だけに効かせる。
//                          全ボス共通のルールにはしない。他の床の帯は今まで通り = 回避の無敵中は当たらないが、
//                          帯は使い切らない (無敵が切れて帯の中に居れば当たる・hits.ts)。
//   ?dodgeFloor=now     : 地割りにも効かせない (10-24 より前の配布版)。
//   ?dodgeFloor=counter : (全ボスの床の帯に) 見切りのあとの反撃の突き (振り始めから滑り終わりまで) の間は、床の帯に当たらない。
//                          突きの間に触れた1回きりの帯は、その突きで抜けたことにして使い切る (滑り終わりに帯の中で止まっても当たらない)。
//                          何度も当たる帯 (茨の床・照明落下) は突きの間だけ当たらず、使い切らない (立ち続ければ当たる)。
//   ?dodgeFloor=spend   : 回避の無敵中に重なった床の帯は、その回避で使い切る (無敵が切れても同じ帯には当たらない)。
//   床の帯 = follow 未指定のゾーン (空気の衝撃波は除く)。近接・飛び道具・怨念は触らない。
//   URL の指定は game.ts の import.meta.env.DEV の中からしか読まない。
//   検収 = kensyu-dodge-floor-rule-1023.html (リポジトリ直下)・調べ = docs/research/2026-10-23-dodge-floor-rule.md
import { PLAYER } from './balance'
import type { ActiveHit, Player } from './types'

export type DodgeFloorMode = 'quake' | 'now' | 'counter' | 'spend'

// 反撃の突きの間は床の帯に当たらない技 (配布版 'quake')。見切りが開く赤い近接と床の帯が同時に出るのは地割りだけ。
const COUNTER_PASS_ATTACK_IDS = new Set(['exec_maulQuake'])

let mode: DodgeFloorMode = 'quake'

export function dodgeFloorMode(): DodgeFloorMode { return mode }
export function setDodgeFloorMode(next: DodgeFloorMode): void { mode = next }
export function setDodgeFloorFromParams(raw: string | null): void {
  if (raw === 'now' || raw === 'counter' || raw === 'spend') mode = raw
}

export function isFloorBand(hit: ActiveHit): boolean {
  return hit.follow === undefined && hit.airWave === undefined && hit.swing !== true
}

// 見切りのあとの反撃の突きを振り始めてから、滑り終わるまで。
function isCounterThrusting(p: Player): boolean {
  return p.state === 'attacking' && p.attackIsCounter && p.stateElapsed * 1000 < PLAYER.attackActiveEndMs
}

// この帯がいま主人公に当たらないか。counter では突きの間に触れた帯へ印を付ける (呼ぶ側が next を差し替える)。
export function dodgeFloorPass(hit: ActiveHit, p: Player, overlaps: () => boolean): { skip: boolean; hit: ActiveHit } {
  if (hit.dodgeSpent) return { skip: true, hit }
  const counterPass = mode === 'counter' || (mode === 'quake' && COUNTER_PASS_ATTACK_IDS.has(hit.attackId))
  if (counterPass && isFloorBand(hit) && isCounterThrusting(p)) {
    return { skip: true, hit: hit.hitOnce && overlaps() ? { ...hit, dodgeSpent: true } : hit }
  }
  return { skip: false, hit }
}

// 回避の無敵で凌いだ床の帯を使い切るか (spend だけ)。
export function dodgeFloorSpendsOnIFrame(hit: ActiveHit): boolean {
  return mode === 'spend' && isFloorBand(hit)
}
